import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function Home() {
    return (_jsx(_Fragment, { children: _jsx("div", { children: "\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C!" }, void 0) }, void 0));
}
export default Home;
